import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface FilesPickerProps {
  multiple: boolean;
}

function FilesPicker({multiple}: FilesPickerProps): JSX.Element {
  return (
    <>
      <input
        type="file"
        multiple={multiple}
        className="hidden file"
        data-test-component="FilesPicker"
        data-test-element="input"
      />
      <div className="drop-help">
        <span className="glyphicon glyphicon-cloud-upload" />
        <span className="instructions">Drag and drop to upload or</span>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          className="file-choose u-mini-spacing-left"
          size={ButtonSize.SMALL}
          text={multiple ? 'Choose files' : 'Choose a file'}
        />
      </div>
      <h5 className="js-files-title hidden">
        {multiple ? 'Files to Upload' : 'File to Upload'} (<span className="js-files-count" />)
      </h5>
      <div className="files-list-wrapper">
        <table className="table table-bordered">
          <tbody className="files-list" />
        </table>
      </div>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<FilesPickerProps>(FilesPicker);
